import { makeStyles } from '@material-ui/styles';

interface LoaderProps {
    length?: number;
}

const Loader: React.FC<LoaderProps> = ({ length = 10 }) => {
    const classes = useStyles();

    return (
        <div className={classes.warpper}>
            {Array.from(Array(length).keys()).map(item => {
                return (
                    <div className={classes.item} key={item}>
                        <span className={classes.placeholderAvatar} />
                        <div className={classes.lines}>
                            <div className={`${classes.line} ${classes.firstLine}`} />
                            <div className={`${classes.line} ${classes.secondLine}`} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        warpper: {
            height: '100%',
            overflow: 'hidden',
        },
        item: {
            width: '100%',
            display: 'flex',
            alignItems: 'space-around',
            padding: '16px 24px',
            borderBottom: `1px solid ${theme.palette.greys[200]}`,
            cursor: 'pointer',
        },
        placeholderAvatar: {
            backgroundColor: theme.palette.greys[400],
            borderRadius: '50%',
            width: '36px',
            height: '36px',
        },
        lines: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            width: 'calc(100% - 36px)',
            paddingLeft: '8px',
        },
        line: {
            backgroundColor: theme.palette.greys[400],
            borderRadius: '16px',
            position: 'relative',
            overflow: 'hidden',
            '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                left: '-150px',
                top: 0,
                height: '100%',
                width: '150px',
                background: `linear-gradient(to right, transparent 0%, ${theme.palette.greys[300]} 50%, transparent 100%)`,
                animation: '$load 2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite',
            },
        },
        firstLine: {
            width: '50%',
            height: '14px',
        },
        secondLine: {
            width: '80%',
            height: '10px',
        },
        '@keyframes load': {
            from: {
                left: '-150px',
            },
            to: {
                left: '100%',
            },
        },
    }),
    { classNamePrefix: Loader.name }
);

export default Loader;
